import Vue from 'vue'
import vuescroll from 'vuescroll'

Vue.use(vuescroll)

Vue.prototype.$vuescrollConfig = {
  vuescroll: {
    mode: 'native',
    sizeStrategy: 'percent',
    detectResize: true,
  },
  rail: {
    opacity: 0,
    keepShow: false,
    size: '7px',
    gutterOfSide: '6px',
  },
  bar: {
    showDelay: 200,
    onlyShowBarOnScroll: true,
    keepShow: true,
    // background: '#F4C000',
    background: 'none',
    opacity: 1,
    hoverStyle: true,
    specifyBorderRadius: '3px',
    minSize: 0.1,
    size: '7px',
    disable: false,
  },
}
